import React from "react";
import { useState, useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewCountryList, editCountry } from "../../Redux/Actions/settingsActions";
import "./editCountry.css";

const EditCountry = () => {
  const { id } = useParams();
  const { countryList } = useSelector((state) => state.country);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [countryData, setCountryData] = useState({
    id: id,
    country_name: "",
    country_code: "",
    country_language_code: "",
    country_language_name: "",
    country_currency_symbol: "",
    country_phone_code: "",
    country_currency: "",
    country_flag: "",
    // country_having: "",
  });

  // const dropdownOptions = ["REGION", "STATE", "PROVINCE", "CITY"];

  useEffect(() => {
    dispatch(viewCountryList({ page: 1, limit: 10 }));
  }, [dispatch]);

  useEffect(() => {
    const list = countryList?.data || [];
    console.log("id from params =>", id);
    console.log("list =>", list);

    if (list.length > 0) {
      const country = list.find((c) => String(c._id) === String(id));
      console.log("matched country =>", country);

      if (country) {
        setCountryData((prev) => ({
          ...prev,
          id: id,
          country_name: country.country_name || "",
          country_code: country.country_code || "",
          country_language_code: country.country_language_code || "",
          country_language_name: country.country_language_name || "",
          country_currency_symbol: country.country_currency_symbol || "",
          country_phone_code: country.country_phone_code || "",
          country_currency: country.country_currency || "",
          country_flag: country.country_flag || "",
          // country_having: country.country_having || "",
        }));
      }
    }
  }, [countryList, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(editCountry(countryData));
      if (response.statusCode === 200) {
        setCountryData({
          id: id,
          country_name: "",
          country_code: "",
          country_language_code: "",
          country_language_name: "",
          country_currency_symbol: "",
          country_phone_code: "",
          country_currency: "",
          country_flag: "",
          // country_having: "",
        });
        navigate("/country");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setCountryData((prevData) => {
      let updatedData = { ...prevData, [name]: value };
      if (name === "country_code") {
        updatedData.country_flag = value.substring(0, 2).toLowerCase() + ".svg";
      }
      // if (name === "country_having") {
      //   updatedData.country_having = value;
      // }
      return updatedData;
    });
  };

  return (
    <MainLayout>
      <div className="ecu-wrapper">

        {/* Header */}
        <div className="ecu-header">
          <div className="ecu-header-left">
            <div className="ecu-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="2" y1="12" x2="22" y2="12" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
              </svg>
            </div>
            <div>
              <h1 className="ecu-title">Edit Country</h1>
              <p className="ecu-subtitle">Update the details for this country</p>
            </div>
          </div>
          <button onClick={() => navigate("/country")} className="ecu-view-btn" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            </svg>
            View Country List
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="ecu-form" noValidate>

          {/* Section 01 — Identity */}
          <div className="ecu-section">
            <div className="ecu-section-header">
              <span className="ecu-section-badge">01</span>
              <h2 className="ecu-section-title">Country Identity</h2>
            </div>
            <div className="ecu-grid ecu-grid-2">
              <div className="ecu-field">
                <label className="ecu-label">Country Name</label>
                <input
                  className="ecu-input"
                  type="text"
                  name="country_name"
                  value={countryData.country_name}
                  onChange={handleAddChange}
                  placeholder="e.g. India"
                />
              </div>
              <div className="ecu-field">
                <label className="ecu-label">Country ISO Code</label>
                <input
                  className="ecu-input"
                  type="text"
                  name="country_code"
                  value={countryData.country_code}
                  onChange={handleAddChange}
                  placeholder="e.g. IN"
                />
                {countryData.country_flag && (
                  <span className="ecu-hint">
                    Flag file: <code className="ecu-code">{countryData.country_flag}</code>
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Section 02 — Language */}
          <div className="ecu-section">
            <div className="ecu-section-header">
              <span className="ecu-section-badge">02</span>
              <h2 className="ecu-section-title">Language</h2>
            </div>
            <div className="ecu-grid ecu-grid-2">
              <div className="ecu-field">
                <label className="ecu-label">National Language</label>
                <input
                  className="ecu-input"
                  type="text"
                  name="country_language_name"
                  value={countryData.country_language_name}
                  onChange={handleAddChange}
                  placeholder="e.g. Hindi"
                />
              </div>
              <div className="ecu-field">
                <label className="ecu-label">Language Code</label>
                <input
                  className="ecu-input"
                  type="text"
                  name="country_language_code"
                  value={countryData.country_language_code}
                  onChange={handleAddChange}
                  placeholder="e.g. hi"
                />
              </div>
            </div>
          </div>

          {/* Section 03 — Currency */}
          <div className="ecu-section">
            <div className="ecu-section-header">
              <span className="ecu-section-badge">03</span>
              <h2 className="ecu-section-title">Currency</h2>
            </div>
            <div className="ecu-grid ecu-grid-2">
              <div className="ecu-field">
                <label className="ecu-label">Country Currency</label>
                <input
                  className="ecu-input"
                  type="text"
                  name="country_currency"
                  value={countryData.country_currency}
                  onChange={handleAddChange}
                  placeholder="e.g. Indian Rupee"
                />
              </div>
              <div className="ecu-field">
                <label className="ecu-label">Currency Symbol</label>
                <input
                  className="ecu-input"
                  type="text"
                  name="country_currency_symbol"
                  value={countryData.country_currency_symbol}
                  onChange={handleAddChange}
                  placeholder="e.g. ₹"
                />
              </div>
            </div>
          </div>

          {/* Section 04 — Contact & Division */}
          <div className="ecu-section">
            <div className="ecu-section-header">
              <span className="ecu-section-badge">04</span>
              <h2 className="ecu-section-title">Contact & Administrative Division</h2>
            </div>
            <div className="ecu-grid ecu-grid-2">
              <div className="ecu-field">
                <label className="ecu-label">Country Phone Code</label>
                <div className="ecu-input-prefix-wrap">
                  <span className="ecu-input-prefix">+</span>
                  <input
                    className="ecu-input ecu-input--prefixed"
                    type="text"
                    name="country_phone_code"
                    value={countryData.country_phone_code}
                    onChange={handleAddChange}
                    placeholder="e.g. 91"
                  />
                </div>
              </div>
              {/* <div className="ecu-field">
                <label className="ecu-label">Administrative Division</label>
                <select
                  className="ecu-select"
                  name="country_having"
                  value={countryData.country_having}
                  onChange={handleAddChange}
                >
                  <option value="">Select an option</option>
                  {dropdownOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>
          </div>

          {/* Footer */}
          <div className="ecu-footer">
            <button
              type="button"
              className="ecu-btn ecu-btn--cancel"
              onClick={() => navigate("/country")}
            >
              Cancel
            </button>
            <button type="submit" className="ecu-btn ecu-btn--submit">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Update Country
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditCountry;